// extracted by mini-css-extract-plugin
export default {"component":"NoContentMessage_component__UPiu8","lightIcon":"NoContentMessage_lightIcon__6gEtP","darkIcon":"NoContentMessage_darkIcon__5pdBr"};